import InvalidFileType from '../exceptions/invalid_file_type'
import InvalidRejectReason from '../exceptions/file_with_context_result/invalid_reject_reason'
import FileWithContext from './file_with_context'

class FileWithContextResult {
  _accepted_files = []
  _rejected_files = []
  set accepted_file(value) {
    if (value instanceof FileWithContext) {
      this._accepted_files = [value, ...this.accepted_files]

      return this
    }

    throw new InvalidFileType(typeof value)
  }
  set accepted_files(value) {
    if (Array.isArray(value)) {
      value.map((v) => (this.accepted_file = v))

      return this
    }

    throw new InvalidFileType(typeof value)
  }
  set rejected_file(value) {
    if (value instanceof FileWithContext) {
      this._rejected_files = [value, ...this.rejected_files]

      return this
    }

    throw new InvalidFileType(typeof value)
  }
  set rejected_files(value) {
    if (Array.isArray(value)) {
      value.map((v) => (this.rejected_file = value))
    }

    throw new InvalidFileType(typeof value)
  }
  get accepted_files() {
    return this._accepted_files
  }
  get rejected_files() {
    return this._rejected_files
  }
}

export default FileWithContextResult
